import React from "react";
import Card from "react-bootstrap/Card";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

function SupportCard() {

   const navigate = useNavigate(); // Initialize navigate
  
    const handleClick = () => {
      navigate("#"); // This will navigate to the "/another-page" route
    };
    const handleClick_1 = () => {
      navigate("#"); // This will navigate to the "/another-page" route
    };
    const handleClick_2 = () => {
      navigate("#"); // This will navigate to the "/another-page" route
    };
    const handleClick_3 = () => {
      navigate("#"); // This will navigate to the "/another-page" route
    };
    const handleClick_4 = () => {
      navigate("#"); // This will navigate to the "/another-page" route
    };
  
  
  return (
    <Card className="quote-card-view">
      <Card.Body>
        {/* <blockquote className="blockquote mb-0"> */}
          <p className="about-text">
          Your support is more than just a donation; it’s an investment in a future where technology empowers every individual
          regardless of their background or life circumstances. When you support Choicest Fruit, you help build a world where
          underserved communities, youth, and seniors can all thrive in a tech-driven society. Together, we can transform lives,
          create lasting change, and foster a more inclusive, innovative world for everyone.
          </p>

          <p className="about-text">
          <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            Why <strong className="purple">Your Support</strong> Matters
            </h4>
            Your support allows us to continue offering hands-on learning experiences that bridge the digital
            divide and create lasting change. Whether it’s giving youth a head start in the tech industry, providing
            seniors with the skills to stay connected, or helping homeless shelter residents find employment opportunities,
            Choicest Fruit® is dedicated to driving purposeful innovation.
            <br/>
            <br/>
          Here’s how your support can make a difference:
          <br />
            <br />
            <li> <b className="purple">Transform Lives:</b> By helping fund our training programs, you enable youth and young adults to pursue careers
              in high-demand STEM fields like software development, electronics, and robotics.</li>
            <li><b className="purple">Bridge the Digital Divide:</b> Your contribution helps us bring digital empowerment to underserved communities
              and seniors who might otherwise be excluded from participating in a tech-driven society.</li>
            <li><b className="purple">Foster Social Change:</b> You’re supporting initiatives like Code & Soil, where technology and organic gardening
              come together to promote collaboration and positive social action in local neighborhoods.</li>
          </p>

          <p className="about-text">
          <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            Our <strong className="purple">Key</strong> Programs
            </h4>
            Here’s a look at the core initiatives that need your support:
            <br />
            <br />
            <li><b className="purple">Tech Innovation Workshops:</b> Empower youth and young adults by providing hands-on training in software development,
              electronics, and robotics, preparing them for careers in STEM fields.</li>
            <li><b className="purple">Digital Empowerment for Shelter Residents: </b> In partnership with Urban Alchemy, this program teaches homeless shelter
              residents vital computer skills that unlock job opportunities and educational resources.</li>
            <li><b className="purple">Digital Literacy Program for Seniors: </b>Help seniors gain the digital literacy skills needed to stay connected with family,
              access online services, and navigate modern technology.</li>
            <li><b className="purple">Code & Soil: </b> This innovative program blends technology with organic gardening to foster collaboration, community engagement,
              and environmental sustainability.</li>
            <li><b className="purple">Summer Youth Employment Program:</b> Offering a 7-week internship program, we provide youth with career training in responsible
              technology development, focusing on ethical tech design and web app development.</li>
          </p>

          <p className="about-text">
          <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            Ways <strong className="purple">You Can</strong> Help
            </h4>
            Your support is crucial in helping us achieve our mission. Here’s how you can get involved:
            <br />
            <br />
            <ol><b className="purple">Donate:</b> Every dollar you contribute directly supports our programs, from providing training materials to funding internships and workshops. Your donation can create real, measurable change.<Button onClick={handleClick}     
      >Donate</Button></ol>
            <ol><b className="purple">Sponsor a Program or Participant: </b> Become a sponsor for one of our programs or sponsor an individual participant, helping them gain valuable tech skills and career exposure.<Button onClick={handleClick_1}     
      >Sponsor</Button></ol>
            <ol><b className="purple">Volunteer Your Time: </b>If you have expertise in technology, education, or community development, we welcome volunteers to mentor, teach workshops, or help with various initiatives.<Button onClick={handleClick_2}     
      >Volunteer</Button></ol>
            <ol><b className="purple">Partner with Us: </b> If you represent a company or organization that shares our vision for empowering communities through technology, consider partnering with Choicest Fruit® to expand our reach and impact.<Button onClick={handleClick_3}     
      >Partner</Button></ol>
            <ol><b className="purple">Spread the Word:</b> Share our mission with your friends, family, and network. The more people who know about our work, the greater the opportunity to expand our reach and help more people.<Button onClick={handleClick_4}     
      >Share</Button></ol>
          </p>

          {/* <footer className="blockquote-footer"></footer>
        </blockquote> */}
      </Card.Body>
    </Card>
  );
}

export default SupportCard;
